import { useCallback } from "react";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { getUserRowDetails } from "api/services/user-service";
import { useDisconnectUserWithLesson } from "hooks/useDisconnectUserWithLesson";
import { useDisconnectUserWithPatron } from "hooks/useDisconnectUserWithPatron";
import { useMakeUserParticipant } from "hooks/useMakeUserParticipant";
import { useMakeUserPatron } from "hooks/useMakeUserPatron";

export const useUserRowDetails = () => {
    const { callAPI, loading } = useWorkspaceApiCall(getUserRowDetails, '', 'getUserRowDetails.error');
    const { disconnectUserWithLesson, disconnectingWithLesson } = useDisconnectUserWithLesson();
    const { disconnectUserWithPatron, disconnectingWithPatron } = useDisconnectUserWithPatron();
    const { makeUserParticipant, makingUserParticipant } = useMakeUserParticipant();
    const { makeUserPatron, makingUserPatron } = useMakeUserPatron();

    const fetchUserRowDetails = useCallback(async (userId: string) => {
        return await callAPI({ userId });
    }, [callAPI]);

    return { 
        fetchUserRowDetails,
        fetchingUserRowDetails: loading,
        disconnectUserWithLesson,
        disconnectingWithLesson,
        disconnectUserWithPatron,
        disconnectingWithPatron,
        makeUserParticipant,
        makingUserParticipant,
        makeUserPatron,
        makingUserPatron
    };
}